import { Box, Tooltip } from "@mui/material";
import { Button } from "@mui/material";
import { ReactComponent as EditSvg } from "../../assets/icons/edit.svg";
import { ReactComponent as DeleteSvg } from "../../assets/icons/delete.svg";
import { useAppDispatch } from "../../app/hooks";
import WarningIconYellow from "../IconComp/warningIconYellow";
import { deleteInstructionDTO } from "../../dtos/instruction";
import AllTable from "../../components/commontable/table";
import { InstructionsHeader } from "../../utils/constants";
import BlockModel from "../../components/common/BlockModel";
import { deleteInstruction } from "../../features/instructions/instructionSlice";
import { styles } from "./styles";
import { useState } from "react";
interface InstructionSectionProps {
  setNewModelInstruction: React.Dispatch<React.SetStateAction<boolean>>;
  instructions: any;
  setEditInstructionID?: any;
}
interface EditIconProps {
  onClick: () => void;
}

const EditIcon: React.FC<EditIconProps> = ({ onClick }) => {
  return (
    <EditSvg
      onClick={onClick}
      width="20px"
      height="20px"
      style={{ cursor: "pointer" }}
    />
  );
};
const DeleteIcon: React.FC<EditIconProps> = ({ onClick }) => {
  return (
    <DeleteSvg
      onClick={onClick}
      width="20px"
      height="20px"
      style={{ cursor: "pointer" }}
    />
  );
};

const InstructionSection: React.FC<InstructionSectionProps> = ({
  setNewModelInstruction,
  instructions,
  setEditInstructionID,
}) => {
  const pharmacyID = Number(localStorage?.getItem("pharmacyId"));
  const dispatch = useAppDispatch();
  const [openInstructionBlock, setOpenInstructionBlock] = useState(false);
  const [deleteId, setDeleteId] = useState(0);

  const handleOpen = (deleteID: any) => {
    setDeleteId(deleteID);
    setOpenInstructionBlock(true);
  };
  const handleCloseInstructionBlock = () => {
    setDeleteId(0);
    setOpenInstructionBlock(false);
  };
  const handleDelete = () => {
    const payload: deleteInstructionDTO = {
      pharmacy_id: pharmacyID,
      instruction_id: deleteId,
    };
    dispatch(deleteInstruction(payload));
    handleCloseInstructionBlock();
  };

  const sortedInstructions = Array.isArray(instructions?.instruction)
    ? [...instructions.instruction].sort(
        (a, b) =>
          new Date(a.created_at).getTime() - new Date(b.created_at).getTime()
      )
    : [];

  const tableRow = sortedInstructions?.map((item: any, index: any) => ({
    Title: item?.title, // Assuming 'policy' should come from 'item'
    Description: item?.description,
    Actions: (
      <Box sx={styles.iconsContainer}>
        <Tooltip title="Edit Instruction">
          <EditIcon
            onClick={() => {
              setNewModelInstruction(true);
              setEditInstructionID(item?.id);
            }}
          />
        </Tooltip>
        <Tooltip title="Delete Instruction">
          <DeleteIcon
            onClick={() => {
              handleOpen(item?.id);
            }}
          />
        </Tooltip>
      </Box>
    ),
  }));

  let isPagination = true;
  return (
    <>
      <Box sx={styles.sectionMain}>
        <Box sx={styles.sectionHeader}>
          <Box sx={styles.sectionMainHeading}>
            Additional Notes/Instructions
          </Box>
          <Button
            variant="contained"
            sx={{
              lineHeight: { xs: "16px", sm: "21px" },
              height: "36px",
              textTransform: "capitalize",
              backgroundColor: "#0055A8",
              fontWeight: "500",
              fontSize: { xs: "12px", sm: "14px" },
              borderRadius: "2px",
              color: "white",
            }}
            onClick={() => {
              setEditInstructionID(0);
              setNewModelInstruction(true);
            }}
          >
            Add New Instructions
          </Button>
        </Box>
        {instructions?.instruction?.length > 0 ? (
          <Box sx={{ marginTop: "9px" }}>
            {" "}
            <AllTable
              headerData={InstructionsHeader}
              rowData={instructions?.instruction?.length > 0 ? tableRow : []}
              isPagination={isPagination}
            />{" "}
          </Box>
        ) : (
          <Box sx={styles.noPolicyContainer}>
            <Box>
              <p style={{ textAlign: "center" }}>No Data Found</p>
            </Box>
          </Box>
        )}
      </Box>
      <BlockModel
        open={openInstructionBlock}
        onClose={handleCloseInstructionBlock}
        heading={"Delete Instruction?"}
        blockText={"Delete"}
        subheading={"Are you sure you want to Delete this Instruction?"}
        onBlock={handleDelete}
      />
    </>
  );
};

export default InstructionSection;
